<template>
    <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal ">
        <!-- <select class="border rounded-md p-1" @blur="updateResponsible" v-model="nextStepResponsible" name="" id="">
            <option :value="null">------</option>
            <option v-for="user in userOptions" :key="user.id" :value="user">
                {{ user.first_name }} {{ user.last_name }}
            </option>
        </select> -->
        {{ nextStepResponsible }}
    </div>
</template>

<script setup>
import {ref, computed, defineProps, defineEmits, watch} from 'vue'

const props = defineProps([
    'nextStep', 'userOptions'
])

const emit = defineEmits([
    'update-next-step'
])


const initialResponsible = computed(() => {
    return props.nextStep.user
})
// const nextStepResponsible = ref(props.nextStep ? props.nextStep.user : null)
const nextStepResponsible = computed(() => {
    if(props.nextStep && props.nextStep.user){
        return `${props.nextStep.user.first_name} ${props.nextStep.user.last_name}`
    } else {
        return "--"
    }
})

// function updateResponsible(){
//     // console.log('update responsible')
//     // console.log('initial responsible', initialResponsible.value)
//     // console.log('update responsible', nextStepResponsible.value)
//     if(nextStepResponsible.value == initialResponsible.value){
//         // console.log('no change')
//     } else {
//         // console.log('change user')
//         emit('update-next-step', 'user', nextStepResponsible.value)
//     }
// }


// watch(() => props.nextStep, () => {
//     if(props.nextStep.user) {
//         nextStepResponsible.value = props.nextStep.user.id
//     } else {
//         nextStepResponsible.value
//     }
// })

</script>